
@if (isVisible) {
  <div>
    <label [for]="controlId" [formGroup]="formGroup">
      <span class="control-label-text" [innerHTML]="componentData.label | safeHtml"></span>
    </label>
    @if (!isEdit) {
	<div>
		@if (!(isLoading$ | async)) {
		<div class="pdf-border">
			<ngx-extended-pdf-viewer [src]="pdfUrl"
									 [textLayer]="true"
									 [showAll]="false"
									 [page]="currentPage"
									 [showToolbar]="false"
									 (pdfLoaded)="onLoadComplete($event)"
									 class="display-block border-one-pixel-solid">
			</ngx-extended-pdf-viewer>
		</div>

		} @else {
		Loading ...
		}
	</div>
    } @else {
      @if (reportTemplate.id !== '-1') {
        <div class="full-width pdf-border">
          The rendered pdf for {{reportName}} will be displayed here.
        </div>
      }
      @if (reportTemplate.id === '-1') {
        <div class="full-width pdf-border">
          {{reportName}}
        </div>
      }
    }
    <div class="grid-x">
      <button class="button hollow small" (click)="download()" >Download <svg-icon icon="icon-download" class="dark-gray"  ></svg-icon></button>
    </div>
  </div>
}




